import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import router from '../router'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 360000
})
// 请求拦截器：携带的token字段
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers.token = getToken()
    }

    if (config.url.indexOf('export/log') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('export/ebikeDebugReport') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('export/ebike') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('importEbikeVin') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('importFenceEbike') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('exportFenceLog') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('importEbikeBaseInfo') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('ebikeCertificateConformity/import') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('export/ebikeModel') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('downloadTempFile') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('export/ebikeMaintainRecord') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('export/ebikeSaleRecord') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('fullEbikeCcc') > -1) {
      config.responseType = 'blob'
    }

    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    if (response.config.url.indexOf('export/log') > -1) {
      return res
    }

    if (response.config.url.indexOf('export/ebike') > -1) {
      return res
    }

    if (response.config.url.indexOf('export/ebikeDebugReport') > -1) {
      return res
    }

    if (response.config.url.indexOf('importEbikeVin') > -1) {
      return res
    }

    if (response.config.url.indexOf('importFenceEbike') > -1) {
      return res
    }

    if (response.config.url.indexOf('exportFenceLog') > -1) {
      return res
    }

    if (response.config.url.indexOf('importEbikeBaseInfo') > -1) {
      return res
    }

    if (response.config.url.indexOf('ebikeCertificateConformity/import') > -1) {
      return res
    }

    if (response.config.url.indexOf('export/ebikeModel') > -1) {
      return res
    }

    if (response.config.url.indexOf('downloadTempFile') > -1) {
      return res
    }

    if (response.config.url.indexOf('export/ebikeMaintainRecord') > -1) {
      return res
    }

    if (response.config.url.indexOf('export/ebikeSaleRecord') > -1) {
      return res
    }

    if (response.config.url.indexOf('fullEbikeCcc') > -1) {
      return res
    }

    if (response.config.url.indexOf('system/api/admin') > -1) {
      if (res.code !== 200) {
        Message({
          message: res.message || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
        if (res.code === 401) {
          router.push('/login')
          Cookies.remove('vue_admin_token')
          localStorage.setItem('buttonPerms', '')
          localStorage.setItem('permName', '')
          localStorage.setItem('clickIndex', 0)
        }
      } else {
        return res
      }
    } else {
      if (res.result) {
        if (res.result.code !== 200) {
          Message({
            message: res.result.errorMsg || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
          if (res.result.code === 401) {
            router.push('/login')
            Cookies.remove('vue_admin_token')
            localStorage.setItem('buttonPerms', '')
            localStorage.setItem('permName', '')
            localStorage.setItem('clickIndex', 0)
          }
        } else {
          return res.result
        }
      } else {
        if (res.code !== 200) {
          Message({
            message: res.message || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
          if (res.code === 401) {
            router.push('/login')
            Cookies.remove('vue_admin_token')
            localStorage.setItem('buttonPerms', '')
            localStorage.setItem('permName', '')
            localStorage.setItem('clickIndex', 0)
          }
        } else {
          return res
        }
      }
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
